import { IonicConfig } from '@ionic/core';

export const options: IonicConfig = {
    rippleEffect: true,
    spinner: 'circles',
    backButtonText: '',
    innerHTMLTemplatesEnabled: true
};
